const runtimeEnv = typeof process !== 'undefined' && process?.env ? process.env : {};
const appEnv = String(runtimeEnv.APP_ENV || runtimeEnv.NODE_ENV || 'dev').trim().toLowerCase();

export function getAppEnv() {
  if (appEnv === 'homolog') throw new Error('APP_ENV=homolog não existe; use staging.');
  if (['prod', 'production'].includes(appEnv)) return 'prod';
  if (appEnv === 'staging') return 'staging';
  return 'dev';
}

export function isProductionAppEnv() {
  return getAppEnv() === 'prod';
}

export function isDevelopmentAppEnv() {
  return getAppEnv() === 'dev';
}

export function isLocalAppEnv() {
  return getAppEnv() === 'dev';
}
